// extracted by mini-css-extract-plugin
export default {"templateIcon":"TemplateIcon_templateIcon__n0-fp"};